// Chose one of the starting points to import

// ==============================================
// Postcss + tailwind
// ==============================================
import "../styles/css/site.css"
import "../styles/css/utilities.css"

// ==============================================
// SCSS
// ==============================================
import "../styles/scss/site.scss"

// Vendor imports
import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse"
import focus from "@alpinejs/focus"
import intersect from "@alpinejs/intersect"
import resize from "@alpinejs/resize"
import breakpoint from "alpinejs-breakpoints"
import $ from "./modules/jquery-global"

Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(resize)


import "lazysizes/plugins/respimg/ls.respimg"
import "lazysizes/plugins/parent-fit/ls.parent-fit"
import "lazysizes"
import "lazysizes/plugins/object-fit/ls.object-fit"
import "@fancyapps/fancybox"

import objectFitVideos from "object-fit-videos"
objectFitVideos()

// Module imports
import "./modules/splide"
import "./modules/svgIconSprite"
import "./modules/googleMaps"
import "./modules/locations"
import "./modules/news"
import "./modules/resources"
import "./modules/glossary"
// import "./modules/carousel"
// Smooth Scroll
import "./modules/lenis"
// Alpine Base
import "./modules/base"

// Trigger resize to initialise modules using the event
setTimeout(() => {
	$(window).trigger("resize")
}, 100)


// Alpine start
window.Alpine = Alpine
window.Alpine.start()

/**
 * Accept hot reloading from dev server
 */
if (import.meta.hot) import.meta.hot.accept()
